// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"ExpandableDescription_descriptionContainer__n_oN8","showLessButton":"ExpandableDescription_showLessButton__gcn27"};